// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"mN-z","inlineTitle":"nN-z","sponsoredAdsWrapper":"oN-z","marketplaceRecosWrapper":"pN-z"};